import utils from '../utils'
import apiClient from './AxiosHttp'

const getStats = (params) => {
    return apiClient.get(`/dashboard/stats/`)
}

const getUsers = (params) => {
    return apiClient.get(`/dashboard/users/list/${params}`)
}

const updateUser = (id, details) => {
    return apiClient.patch(`/dashboard/user/modify/${id}/`, details)
}

const deleteUser = (id) => {
    return apiClient.delete(`/dashboard/user/modify/${id}/`)
}

const addUser = (details) => {
    return apiClient.post(`/dashboard/user/create/`, details)
}

const getProducts = (params) => {
    return apiClient.get(`/dashboard/products/list/${params}`)
}

const getProduct = () => {

}

const createProduct = (details) => {
    return apiClient.post(
        `/dashboard/products/create/`,
        details,
        { headers: utils.multipartHeader }
    )
}

const updateProduct = (id, details) => {
    return apiClient.patch(
        `/dashboard/products/get/${id}/`,
        details,
        { headers: utils.multipartHeader }
    )
}

const deleteProduct = (id) => {
    return apiClient.delete(`/dashboard/products/get/${id}/`)
}

const addProductMedia = (details) => {
    return apiClient.post(
        `/dashboard/product/media/create/`,
        details,
        { headers: utils.multipartHeader }
    )
}

const deleteProductMedia = (id) => {
    return apiClient.delete(`/dashboard/product/media/delete/${id}/`)
}

const getServices = (params) => {
    return apiClient.get(`/dashboard/services/list/${params}`)
}

const getPurchases = (params) => {
    return apiClient.get(`/dashboard/purchases/list/${params}`)
}

const updatePayment = (id, details) => {
    return apiClient.patch(`/dashboard/payment/get/${id}/`, details)
}

const deleteProductType = (id) => {
    return apiClient.delete(`/dashboard/product/type/get/${id}/`)
}

const updateProductType = (id, data) => {
    return apiClient.patch(
        `/dashboard/product/type/get/${id}/`,
        data,
        { headers: utils.multipartHeader }
    )
}

const getStores = (params) => {
    return apiClient.get(`/dashboard/stores/list/${params}`)
}

const updateStore = (id, details) => {
    return apiClient.patch(
        `/dashboard/stores/get/${id}/`,
        details,
        { headers: utils.multipartHeader }
    )

}

const deleteStore = (id) => {
    return apiClient.delete(`/dashboard/stores/get/${id}/`)
}

const getRefunds = (params) => {
    return apiClient.get(`/dashboard/refunds/list/${params}`)
}

const updateRefund = (id, details) => {
    return apiClient.patch(`/dashboard/refunds/get/${id}/`, details)
}


const adminUserStats = () => {
    return apiClient.get(`/dashboard/metrics/users/`)
}

const adminStoreStats = () => {
    return apiClient.get(`/dashboard/metrics/stores/`)
}

const productStats = () => {
    return apiClient.get(`/dashboard/metrics/products/`)
}

const paymentsStats = () => {
    return apiClient.get(`/dashboard/metrics/payments/`)
}

const refundsStats = () => {
    return apiClient.get(`/dashboard/metrics/refunds/`)
}

const paymentCharts = (params) => {
    return apiClient.get(`/dashboard/metrics/payments/charts/${params}`)
}


const adminServices = {
    getStats,
    getUsers,
    updateUser,
    deleteUser,
    addUser,
    getProducts,
    createProduct,
    updateProduct,
    deleteProduct,
    addProductMedia,
    deleteProductMedia,
    getServices,
    getPurchases,
    getProduct,
    updatePayment,
    deleteProductType,
    updateProductType,
    getStores,
    updateStore,
    deleteStore,
    getRefunds,
    updateRefund,
    adminUserStats,
    adminStoreStats,
    productStats,
    paymentsStats,
    refundsStats,
    paymentCharts,
}

export default adminServices